import React from "react";
import { Link } from "react-router-dom";
import { ageCalculate } from "../utils/utils.js";

const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .toString()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const formatCreatedDateTime = (dateVal) => {
  if (!dateVal) return null;
  try {
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return null;
    const dateStr = d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
    const timeStr = d.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
    return `${dateStr} ${timeStr}`;
  } catch {
    return null;
  }
};

export const memberColumns = ({ statusChange, handleDelete, handleSoftDelete, handleRestore, handlePermanentDelete, handleMemberLogin, PAGE_SIZE, onProfileStatusClick }) => [
  {
    label: "ID",
    width: 90,
    render: (row) =>
      row.profile_id ? (
        <div style={{ lineHeight: "1.3" }}>
          <Link
            to={`/user/view-member/${row._id}`}
            style={{ fontWeight: "700", color: "#b82e66", textDecoration: "none", fontSize: "12px" }}
          >
            {row.profile_id}
          </Link>
          {row.isDeleted && (
            <div>
              <span style={{ backgroundColor: "#d9534f", color: "#fff", fontSize: "9px", padding: "1px 5px", borderRadius: "3px", display: "inline-block", marginTop: "2px", fontWeight: "bold" }}>
                Soft Deleted
              </span>
            </div>
          )}
          <div style={{ marginTop: "2px" }}>
            <button
              type="button"
              onClick={() => handleMemberLogin(row)}
              style={{ border: "none", background: "none", padding: 0, color: "#337ab7", fontSize: "11px", cursor: "pointer", display: "block", textAlign: "left" }}
            >
              Login Member
            </button>
            <Link
              to={`/user/login-history/${row.profile_id}`}
              style={{ color: "#73879C", fontSize: "10px", textDecoration: "none", display: "block" }}
            >
              History
            </Link>
          </div>
        </div>
      ) : <span className="text-muted">-</span>,
  },

  {
    label: "User Details",
    key: "name",
    width: 200,
    sortable: true,
    render: (row) => {
      const hasName = row.name && row.name.trim() !== "" && row.name !== "-";
      const hasEmail = row.email && row.email.trim() !== "" && row.email !== "-";
      const hasPhone = row.mobile || row.contact_no;
      const hasGender = row.gender && row.gender !== "-";
      const hasDob = row.dob;
      const createdDateStr = formatCreatedDateTime(row.createdAt);
      const formattedName = hasName ? capitalizeWords(row.name) : "Unnamed";

      return (
        <div className="userdet" style={{ lineHeight: "1.3", fontSize: "11.5px", whiteSpace: "normal" }}>
          <div style={{ display: "flex", alignItems: "center", fontWeight: "600", color: "#2A3F54", textTransform: "capitalize", lineHeight: "1.3" }}>
            <span style={{ width: "16px", minWidth: "16px", height: "16px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "6px", flexShrink: 0 }}>
              <i className="far fa-user" style={{ color: "#b82e66", fontSize: "12px", margin: 0 }} />
            </span>
            <span style={{ lineHeight: "1.3" }}>{formattedName}</span>
          </div>
          {hasPhone && (
            <div style={{ display: "flex", alignItems: "center", color: "#475569", lineHeight: "1.3" }}>
              <span style={{ width: "16px", minWidth: "16px", height: "16px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "6px", flexShrink: 0 }}>
                <i className="far fa-mobile" style={{ color: "#b82e66", fontSize: "13px", margin: 0 }} />
              </span>
              <span style={{ lineHeight: "1.3" }}>{row.mobile || row.contact_no}</span>
            </div>
          )}
          {hasEmail && (
            <div style={{ display: "flex", alignItems: "center", color: "#475569", wordBreak: "break-all", fontSize: "11px", lineHeight: "1.3" }}>
              <span style={{ width: "16px", minWidth: "16px", height: "16px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "6px", flexShrink: 0 }}>
                <i className="far fa-envelope" style={{ color: "#b82e66", fontSize: "11px", margin: 0 }} />
              </span>
              <span style={{ lineHeight: "1.3" }}>{row.email || row.contact_email}</span>
            </div>
          )}
          {(hasGender || hasDob) && (
            <div style={{ display: "flex", alignItems: "center", color: "#64748b", fontSize: "11px", lineHeight: "1.3" }}>
              <span style={{ width: "16px", minWidth: "16px", height: "16px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "6px", flexShrink: 0 }}>
                <i
                  className={`far ${hasGender && String(row.gender).toLowerCase() === "female"
                    ? "fa-venus"
                    : hasGender && String(row.gender).toLowerCase() === "male"
                      ? "fa-mars"
                      : hasGender
                        ? "fa-venus-mars"
                        : "fa-birthday-cake"
                    }`}
                  style={{ color: "#b82e66", fontSize: "12px", margin: 0 }}
                />
              </span>
              <span style={{ whiteSpace: "nowrap", lineHeight: "1.3" }}>
                {hasGender && row.gender}
                {hasGender && hasDob ? ", " : ""}
                {hasDob && `${ageCalculate(row.dob)} yrs`}
              </span>
            </div>
          )}
          {createdDateStr && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#64748b",
                fontSize: "11px",
                flexWrap: "nowrap",
                lineHeight: "1.3",
              }}
              title="Registered Date"
            >
              <span style={{ width: "16px", minWidth: "16px", height: "16px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "6px", flexShrink: 0 }}>
                <i
                  className="far fa-calendar-alt"
                  style={{
                    color: "#b82e66",
                    fontSize: "11px",
                    margin: 0,
                  }}
                />
              </span>
              <span style={{ whiteSpace: "nowrap", lineHeight: "1.3" }}>{createdDateStr}</span>
            </div>
          )}
        </div>
      );
    },
  },
  {
    label: "Profile",
    width: 65,
    render: (row) => (
      <span style={{ fontSize: "12px", fontWeight: "600" }}>
        {row.profile_completion || (row.profile_completion_pct !== undefined ? `${row.profile_completion_pct}%` : "-")}
      </span>
    ),
  },

  {
    label: "Location",
    width: 80,
    render: (row) => {
      const city = row.loc_city?.name || (typeof row.loc_city === 'string' ? row.loc_city : "");
      const state = row.loc_state?.name || (typeof row.loc_state === 'string' ? row.loc_state : "");
      const locText = city || state ? (city && state ? `${city}, ${state}` : city || state) : "-";
      return (
        <span style={{ fontSize: "12px", color: "#475569", whiteSpace: "normal" }} title={locText}>
          {city || state || "-"}
        </span>
      );
    },
  },

  {
    label: "Plan",
    width: 75,
    render: (row) => {
      const planName = row.userPlan?.plan_id?.name || row?.membershipPlan?.name;
      return (
        <span style={{ fontSize: "12px", color: planName ? "#b82e66" : "#64748b", fontWeight: planName ? "600" : "normal" }}>
          {planName ? planName : "Free"}
        </span>
      );
    },
  },
  {
    label: "Approval",
    width: 80,
    render: (row) => {
      if (row?.profileApproval === 'Pending' || row?.profileApproval === 'Rejected') {
        return (
          <span
            className={`statusprogress ${row.profileApproval === 'Pending' ? 'pending' : 'rejected'}`}
            style={{ cursor: 'pointer', textDecoration: 'underline', fontSize: "11px" }}
            onClick={() => onProfileStatusClick && onProfileStatusClick(row)}
          >
            {row.profileApproval}
          </span>
        );
      }
      if (row?.profileApproval === 'Approved') {
        return <span className="verifystatus approved" style={{ fontSize: "11px" }}>Approved</span>;
      }
      return <span className="statusprogress pending" style={{ fontSize: "11px" }}>Pending</span>;
    },
  },
  {
    label: "Source",
    width: 65,
    render: (row) => (
      <span style={{ fontSize: "11px", color: "#64748b" }}>
        {row.signup_source_type || '-'}
      </span>
    ),
  },
  {
    label: "Status",
    width: 75,
    render: (row) => (
      <div className="checkbox-wrapper-8" style={{ marginTop: "1px" }}>
        <input
          className="tgl tgl-skewed"
          id={`cb3-${row._id}`}
          type="checkbox"
          checked={row.status === 'Active'}
          onClick={(e) => statusChange(e, row._id, row.status)}
        />
        <label
          className="tgl-btn"
          data-tg-off="Deactive"
          data-tg-on="Active"
          htmlFor={`cb3-${row._id}`}
        />
      </div>
    ),
  },

  {
    label: "Action",
    width: 95,
    render: (row) => (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginTop: "2px" }}>
        <Link
          to={`/user/view-member/${row._id}`}
          title="View Member"
          style={{ color: "#337ab7", fontSize: "14px", textDecoration: "none" }}
        >
          <i className="fa fa-eye" />
        </Link>
        <Link
          to={`/user/edit-member/${row._id}`}
          title="Edit Member"
          style={{ color: "#26b99a", fontSize: "14px", textDecoration: "none" }}
        >
          <i className="fa fa-pencil" />
        </Link>
        {row.isDeleted ? (
          <>
            <Link
              to="#"
              title="Restore Member"
              onClick={(e) => {
                e.preventDefault();
                if (handleRestore) handleRestore(row._id);
              }}
              style={{ color: "#28a745", fontSize: "14px", textDecoration: "none" }}
            >
              <i className="fa fa-undo" />
            </Link>
            <Link
              to="#"
              title="Permanently Delete Member (Admin/Agent only)"
              onClick={(e) => {
                e.preventDefault();
                if (handlePermanentDelete) handlePermanentDelete(row._id);
                else handleDelete(row._id);
              }}
              style={{ color: "#d9534f", fontSize: "14px", textDecoration: "none" }}
            >
              <i className="fa fa-trash" />
            </Link>
          </>
        ) : (
          <>
            <Link
              to="#"
              title="Soft Delete Member"
              onClick={(e) => {
                e.preventDefault();
                if (handleSoftDelete) handleSoftDelete(row._id);
                else handleDelete(row._id);
              }}
              style={{ color: "#f0ad4e", fontSize: "14px", textDecoration: "none" }}
            >
              <i className="fa fa-ban" />
            </Link>
            <Link
              to="#"
              title="Permanently Delete Member (Admin/Agent only)"
              onClick={(e) => {
                e.preventDefault();
                if (handlePermanentDelete) handlePermanentDelete(row._id);
                else handleDelete(row._id);
              }}
              style={{ color: "#d9534f", fontSize: "14px", textDecoration: "none" }}
            >
              <i className="fa fa-trash" />
            </Link>
          </>
        )}
      </div>
    ),
  },

];
